module.exports = __webpack_public_path__ + "static/media/Group 1597880740@2x.ae1479b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/Group 1597880740@2x.png
// module id = 1208
// module chunks = 0